import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BusinessProfileActions } from '../_actions';
import Spinner from '../_components/Spinner';
import { Table } from 'react-bootstrap';
import NoResults from '../_components/NoResults';
import ModalCreateUser from '../_components/ModalCreateUser';

function Users() {
  const dispatch = useDispatch();
  const { users, isLoading } = useSelector(
    (state) => state.businessProfileReducers
  );
  const [show, setShow] = useState(false);

  useEffect(() => {
    dispatch(BusinessProfileActions.BusinessGetUsers());
  }, [dispatch]);

  function renderTable() {
    if (isLoading) {
      return <Spinner />;
    }

    return (
      <Table striped hover className="table-principal">
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Puesto</th>
            <th>PERMISOS</th>
          </tr>
        </thead>
        <tbody>
          {users?.results?.length ? (
            users.results.map((job) => (
              <tr key={job.id}>
                <td>
                  {job.first_name} {job.last_name}
                </td>
                <td>{job.role}</td>
                <td>
                  <span>{job.user_type}</span>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="3">
                <NoResults />
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    );
  }

  function handleClose() {
    setShow(false);
    dispatch(BusinessProfileActions.BusinessGetUsers());
  }

  function handleShow() {
    setShow(true);
  }

  return (
    <div className="users">
      {show ? <ModalCreateUser handleClose={handleClose} show={show} /> : ''}

      <div className="clear">
        <button
          className="btn btn-primary float-right radio25"
          onClick={handleShow}
        >
          Añadir usuario
        </button>
      </div>
      <h3 className="news-title">EQUIPO Y PERMISOS</h3>
      <div className="row">
        <div className="col-md-12">{renderTable()}</div>
      </div>
    </div>
  );
}

export { Users };
